<template lang="pug">
#portfolio
  //- .title.is-3 {{ STOCKED.all_holdings.length }} - {{ STOCKED.all_sectors.length }} - {{ STOCKED.all_countries.length }}
  //- pre {{ STOCKED.all_holdings[0] }}
  //- pre {{ STOCKED.all_holdings[1000] }}
  //- pre {{ selected_funds }}
  //- pre {{ available_funds_to_select() }}
  //- pre {{ total_owned }}
  .subtitle.is-4(style='margin-bottom: 0.75rem')
    | Your index funds portfolio:
    //- span.button.is-small(@click='addFund' v-if='available_funds_to_select().length > 0') ➕ Add fund
  table.selected_funds.mobile_table.table.is-narrow.is-hoverable.is-borderless
    tbody
      tr(v-for='fund in selected_funds')
        td
          p.control(style='text-align: right;'): span.select: select(v-model='fund.symbol')
            option(v-for="fund in available_funds_to_select(fund.symbol)", :value='fund.symbol') {{ fund.name }}
        td: .field.has-addons(style='justify-content: flex-end;')
          p.control.has-icons-left(style='margin: 0')
            //- a.button.is-static {{ selected_currency }}
            input.input(type='number', placeholder='Amount of money', v-model.lazy.number='fund.invested' style='width: 150px;')
            span.icon.is-small.is-left: i.fas.fa-dollar-sign
        td.has-text-right
          a(:href='fund_link(fund.symbol)' target='_blank') Vanguard {{ fund.symbol }}
        td: .button.is-small.has-text-danger(@click='removeFund(fund)' v-if='selected_funds.length > 1') delete
</template>


<script>
const axios = require('axios')

export default {
  name: 'portfolio',
  data() {
    let initial_selected_funds = [{ symbol: 'VEQT.TO', invested: 100000, loaded: false }]
    if (this.$route.query.portfolio) {
      initial_selected_funds = _.map(this.$route.query.portfolio.split(','), str => ({ symbol: str.split('_')[0], invested: parseFloat(str.split('_')[1]), loaded: false }))
    }
    return {
      all_funds: [
        // { name: '🌐 All World - VT, VTWSX'        , symbol: 'VT'    ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/3141' },
        // { name: '🌐 Developed World - VEA, VTMGX' , symbol: 'VEA'   ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/0936' },
        // { name: '🌐 Developed Europe - VGK, VEUSX', symbol: 'VGK'   ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/0963' },
        // { name: '🌐 Developed Asia - VPL, VPADX'  , symbol: 'VPL'   ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/0962' },
        // { name: '🌐 Emerging Markets - VWO, VEMAX', symbol: 'VWO'   ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/0964' },
        // { name: '🇺🇸 All USA - VTI, VTSAX'         , symbol: 'VTI'   ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/0970' },
        // { name: '🇺🇸 World ex US - VXUS, VTIAX'    , symbol: 'VXUS'  ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/3369' },
        // { name: '🇺🇸 USA S&P 500 - VOO, VFIAX'     , symbol: 'SP500' ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/0968' },
        // { name: '🇺🇸 USA Real Estate - VNQ, VGSLX' , symbol: 'VNQ'   ,  link: 'https://advisors.vanguard.com/web/c1/fas-investmentproducts/0986' },
        {
          name: '🇨🇦 All Canada - Vanguard VCN.TO',
          symbol: 'VCN.TO',
          link: 'https://www.vanguard.ca/en/investor/products/products-group/etfs/VCN'
        },
        {
          name: '🇨🇦 All-Equity ETF Portfolio — Vanguard VEQT.TO',
          symbol: 'VEQT.TO',
          link: 'https://www.vanguard.ca/en/investor/products/products-group/etfs/VEQT'
        },
        // { name: '🇨🇦 World ex Canada - VXC.TO'     , symbol: 'VXC.TO',  link: 'https://www.vanguardcanada.ca/advisors/adv/en/product.html#/fundDetail/etf/portId=9548/assetCode=equity/?overview' },
        // { name: '🇨🇦 Developed ex NA - VIU.TO'     , symbol: 'VIU.TO',  link: 'https://www.vanguardcanada.ca/advisors/adv/en/product.html#/fundDetail/etf/portId=9569/assetCode=equity/?overview' },
        // {
        //   name: '🇨🇦 Canadian Real Estate - VRE.TO',
        //   symbol: 'VRE.TO',
        //   link: 'https://www.vanguard.ca/en/investor/products/products-group/etfs/VRE'
        // }
      ],
      all_currencies: ['$', '€', '£', '¥'],
      selected_funds: initial_selected_funds,
      funds_data: {} // Just a cache for loaded JSONs
    }
  },
  computed: {
    total_owned() {
      return _.sumBy(this.selected_funds, 'invested')
    },
    all_holdings() {
      const loaded_funds = _.map(_.filter(this.selected_funds, 'loaded'), 'symbol')
      const portfolio = _.pick(this.funds_data, loaded_funds)
      _.each(portfolio, (holdings, symbol) => {
        const invested_in_symbol = _.find(this.selected_funds, fund => fund.symbol == symbol).invested
        _.map(holdings, (h) => {
          h.owned = invested_in_symbol * h.real_percentage
          h.fund_symbol = symbol
          h.owned_in_funds = {}
          h.owned_in_funds[h.fund_symbol] = h.owned
          h.real_percentage_formatted = [`${h.real_percentage_f} <em>${h.fund_symbol}</em>`]
          h.percentage_in_funds = {}
          h.percentage_in_funds[h.fund_symbol] = h.real_percentage
        })
      })
      STOCKED.portfolio_size = _.sumBy(this.selected_funds, 'invested')

      const all_holdings = _.flatten(_.values(_.pick(this.funds_data, loaded_funds)))
      const grouped_holdings = {}

      _.each(all_holdings, (h) => {
        if (grouped_holdings[h.name]) {
          grouped_holdings[h.name].owned += h.owned
          grouped_holdings[h.name].real_percentage_formatted = _.concat(grouped_holdings[h.name].real_percentage_formatted, h.real_percentage_formatted)
          grouped_holdings[h.name].owned_in_funds[h.fund_symbol] += h.owned
          grouped_holdings[h.name].percentage_in_funds[h.fund_symbol] += h.real_percentage
        } else {
          grouped_holdings[h.name] = h
        }
      })

      STOCKED.all_holdings = _.values(grouped_holdings)
      return STOCKED.all_holdings
    }
  },
  watch: {
    'STOCKED.selected_currency': {
      handler(_val) {
        localStorage.setItem('selected_currency', this.STOCKED.selected_currency)
      }
    },
    selected_funds: {
      handler(val) {
        localStorage.setItem('selected_funds', JSON.stringify(val))
        this.fetchHoldings()
      },
      deep: true,
      immediate: true
    },
    all_holdings: {
      handler() {
        this.$set(this.STOCKED, 'all_countries', _.uniq(_.map(_.sortBy(this.all_holdings, 'raw_country'), 'country')))
        this.$set(this.STOCKED, 'all_sectors', _.uniq(_.map(_.sortBy(this.all_holdings, 'sector'), 'sector')))
      }
    }
  },
  mounted() {
    this.savePortfolioToURL()
  },
  methods: {
    fund_link(symbol) {
      return _.find(this.all_funds, { symbol }).link
    },
    available_funds_to_select(currently_selected_fund = 'abra-cadabra') {
      const selected_funds_symbols = _.map(this.selected_funds, fund => fund.symbol)
      return _.filter(this.all_funds, fund => fund.symbol == currently_selected_fund || !_.includes(selected_funds_symbols, fund.symbol))
    },
    addFund() {
      mixpanel.track('added fund')
      const next_available_fund = this.available_funds_to_select()[0].symbol
      this.selected_funds.push({ symbol: next_available_fund, invested: 100000, loaded: false })
    },
    removeFund(fund) {
      mixpanel.track('removed fund')
      this.$delete(this.selected_funds, _.indexOf(this.selected_funds, fund))
    },
    percentage(invested) {
      return `${_.round((invested / this.total_owned) * 100, 1)}%`
    },
    fetchHoldings() {
      this.selected_funds.forEach((fund) => {
        if (!this.funds_data[fund.symbol]) {
          fund.loaded = false
          axios.get(`/funds/${fund.symbol}.json`).then((response) => {
            const holdings = response.data.data
            this.$set(this.funds_data, fund.symbol, holdings)
            fund.loaded = true
          })
        } else {
          fund.loaded = true
        }
      })
    },
    savePortfolioToURL() {
      this.$watch('selected_funds', () => {
        const query = _.clone(this.$route.query)
        query.portfolio = _.map(this.selected_funds, fund => `${fund.symbol}_${fund.invested}`).join(',')
        this.$router.replace({ name: this.$route.name, query })
      }, { deep: true })
    },
  }
}
</script>

<style lang="sass">
table.selected_funds
  margin-bottom: 1em
  td
    vertical-align: middle
  input
    text-align: right
</style>
